export const COLUMNS = [
  {
    Header: "Vacancy Id",
    accessor: "_id",
  },
  {
    Header: "Vacancy",
    accessor: "vacancy",
  },
  {
    Header: "Job Category",
    accessor: "job_category",
  },
  {
    Header: "Location",
    accessor: "location",
  },
  {
    Header: "Position Type",
    accessor: "position_type",
  },
  {
    Header: "Salary",
    accessor: "salary",
  },
];
